import React, { useEffect, useReducer , useState } from 'react';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
// import {  useParams } from 'react-router';

import { useNavigate, useParams, Link } from 'react-router-dom';

import { competitionService } from './competitionService';
import { ShowSelector } from '../show';
import { DisciplineSelector } from '../discipline';
import { FormObjectList } from '../common';
import { HorseSelector } from '../horse';
import { useAuth } from '../auth/Authcontext';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2'
import { disciplineService } from "../discipline/disciplineService";

const statusOptions = [
    'Open',
    'Closed',
    'Ranked'
]

const ribbonOptions = [
    'None',
    'First',
    'Second',
    'Third'
]

const initialState = {
    isLoading: true,
    isSubmitting: false,
    isEditting: false,
    competition: undefined,
}

const ACTIONS = {
    COMPETITION_GET_CALL: 'COMPETITION_GET_CALL',
    COMPETITION_GET_SUCCESS: 'COMPETITION_GET_SUCCESS',
    COMPETITION_GET_ERROR: 'COMPETITION_GET_ERROR',
    TOGGLE_EDIT: 'TOGGLE_EDIT',
    COMPETITION_UPDATE_CALL: 'COMPETITION_UPDATE_CALL',
    COMPETITION_UPDATE_SUCCESS: 'COMPETITION_UPDATE_SUCCESS',
    COMPETITION_UPDATE_ERROR: 'COMPETITION_UPDATE_ERROR'
}

function reducer(state, action) {
    switch (action.type) {

        case ACTIONS.COMPETITION_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                isEditting: true,
            }
        case ACTIONS.COMPETITION_GET_CALL:
            return {
                ...state,
                isLoading: true
            }
        case ACTIONS.COMPETITION_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                competition: {
                    ...action.data
                }
            }
        case ACTIONS.TOGGLE_EDIT:
            let isEditting = !state.isEditting
            return {
                ...state,
                isEditting: isEditting
            }
        case ACTIONS.COMPETITION_UPDATE_CALL:
            return {
                ...state,
                isSubmitting: true,
                isLoading: true
            }
        case ACTIONS.COMPETITION_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                isEditting: false,
                competition: {
                    ...action.data
                }
            }
        default:
            throw new Error(`No action of type ${action.type} found in reducer.`)
    }
}

function CompetitionEdit() {
    const { contextValue } = useAuth();

    const { competitionId } = useParams();
    const [state, dispatch] = useReducer(reducer, initialState);
    const { register, handleSubmit, setValue,control, reset, formState: { errors } } = useForm();
    const { fields, append, remove } = useFieldArray({ control, name: 'competition.horses' });
    // const history = useHistory();
    const navigate = useNavigate();
    const [deciples, setDisciples] = useState(null);
    const divForScroll = React.useRef(null);


    useEffect(() => {
        handleSlectorInputChange('');
    }, []);
    useEffect(() => {
        dispatch({ type: ACTIONS.COMPETITION_GET_CALL });
        competitionService.getCompetition(competitionId)
            .then(response => {
                
                dispatch({ type: ACTIONS.COMPETITION_GET_SUCCESS, data: response.data })})
            .catch(error => console.error(error));
    }, [competitionId]);

    useEffect(() => {
        if (state.competition || !state.isEditting) {
            reset({ competition: state.competition });
          
        }

        if (state.competition && state.competition.disciplineId) {
            setValue("DisciplineId", state.competition.disciplineId); // ✅ sets RHF value
          }
    }, [state.competition, state.isEditting, reset]);

    function handleEditClick(event) {
        event.preventDefault();
        dispatch({ type: ACTIONS.TOGGLE_EDIT });
    }

    function handleDeleteClick(event) {
        event.preventDefault();
        // if (window.confirm(`This will permanently delete the record for ${state.competition.name}, and any asscoiated records such as scores and ranks. There is no way to undo this action. Press 'Ok' if you are sure you want to delete ${state.competition.name}.`)) {
        //     competitionService.deleteCompetition(competitionId);
        //     window.alert(`${state.competition.name} has been deleted.`);
        //     navigate('/competition');
        // }


        const message = `This will permanently delete the record for ${state.competition.name}, and any asscoiated records such as scores and ranks. There is no way to undo this action.`

        Swal.fire({
            title: 'Are you sure?',
            text: message,
            // icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            heightAuto: false
        }).then((result) => {
            if (result.isConfirmed) {

                contextValue.showLoader();
                contextValue.updateLoaderText("Deleting competition...");

                competitionService.deleteCompetition(competitionId).then(response => {
                    toast.success(`${state.competition.name} has been deleted.`);
                    navigate('/show/'+state.competition.show.id);
                })
                    .catch(error => {
                        console.error(error);
                        toast.error("Error deleting competition");
                    })
                    .finally(() => contextValue.hideLoader());

                // delete logic here
            }
        });
    }


    function handleSlectorInputChange(value) {
        disciplineService.indexDisciplines({
            sortOrder: null,
            searchString: value,
            pageSize: 100,
            pageNumber: 1
        })
            .then(response => {
                setDisciples(response.data.entities)
            }

            )
            .catch(error => console.error(error));
    }

    function handleSaveClick({ competition }) {
        dispatch({ type: ACTIONS.COMPETITION_UPDATE_CALL });
        let horses = null

        if(competition.horses && competition.horses.length > 0) {
            horses = competition.horses.map((item) => {
                return {
                    ...item,
                    horseId: item.horse.id
                }
            });
        }

        contextValue.showLoader();
        contextValue.updateLoaderText("Updating competition...");

        competitionService.updateCompetition(competitionId, {
            ...competition,
            disciplineId: competition.discipline?.id,
            showId: competition.show?.id,
            horses: horses
        })
            .then(response => {
                dispatch({ type: ACTIONS.COMPETITION_UPDATE_SUCCESS, data: response.data })
                toast.success("Competition updated successfully");
            })
            .catch(error => {

                console.log(error.response.data);
                dispatch({ type: ACTIONS.COMPETITION_UPDATE_ERROR });

                if (error.response.data.isError) {
                    const message = error.response.data.messages.map(value => value).join("\n");
                    toast.error(message);

                } else {
                    toast.error("Error updating competition");
                }


                dispatch({ type: ACTIONS.COMPETITION_UPDATE_ERROR, data: error.response.data })
            })
            .finally(() => contextValue.hideLoader());



    }

    function handleNewCompetitionHorseClick(event) {
        event.preventDefault();
        append({
            horse: undefined,
            backNumber: 0,
        });

        divForScroll.current?.scrollIntoView({ behavior: 'smooth', block: "center"  });
        divForScroll.current?.focus();
    }

    function renderStatusOptions() {
        return statusOptions.map((item) => (
            <option key={`status${item}`} value={item}>{item}</option>
        ));
    }

    function renderRibbonOptions() {
        return ribbonOptions.map((item) => (
            <option key={`ribbon${item}`} value={item}>{item}</option>
        ));
    }

    function handleBackClick(event) {
        event.preventDefault();
        navigate("/show/" + state.competition.show.id);
    }

    function renderCompetitionHorse(index) {
        return (
            <div className='card mb-3 '>
                <div className="card-body row">
                    <div className="col">
                        <div className="row mb-3">
                            <div className="col">
                                <label htmlFor={`horse${index}`} className="form-label">Horse:</label>
                                <Controller
                                    control={control}
                                    name={`competition.horses[${index}].horse`}
                                    render={({ field: { onChange, value } }) => (
                                        <HorseSelector className='form-control' id={`horse${index}`} value={value} onChange={onChange} disabled={!state.isEditting} />
                                    )}
                                />
                            </div>
                            <div className="col">
                                <label htmlFor={`backNumber${index}`} className="form-label">Back Number:</label>
                                <input type='text' className='form-control' id={`backNumber${index}`} {...register(`competition.horses[${index}].backNumber`)} disabled={!state.isEditting} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col">
                                <label htmlFor={`place${index}`} className="form-label">Place:</label>
                                <input type='text' className='form-control' id={`place${index}`} autoComplete='off' {...register(`competition.horses[${index}].place`)} disabled={true} />
                            </div>
                            <div className="col">
                                <label htmlFor={`ribbon${index}`} className="form-label">Ribbon:</label>
                                <select className='form-select' id={`ribbon${index}`} {...register(`competition.horses[${index}].ribbon`)} disabled={true}>
                                    {renderRibbonOptions()}
                                </select>
                            </div> 
                            <div className="col">
                                <label htmlFor={`points${index}`} className="form-label">Points:</label>
                                <input type='text' className='form-control' id={`points${index}`} autoComplete='off' 
                                {...register(`competition.horses[${index}].points`)} disabled={true} defaultValue={0} />
                            </div>
                        </div> 
                    </div>
                    {state.isEditting &&
                        <div className="col-auto">
                            <button type='button' className='btn btn-danger text-white' onClick={() => remove(index)}>
                                <i className="bi bi-x-lg me-2"></i>
                                Remove
                            </button>
                        </div>
                    }
                </div>
            </div>
        );
    }

    return (
        <div className='container h-100 '>
            {!state.isLoading &&
                <form>
                    <div className="row mb-3">
                        <h2 className='col'>{state.competition.name}</h2>
                        {!state.isEditting &&
                            <div className='col-auto'>

<button className='btn btn-primary me-2' onClick={handleBackClick}>Back</button>

                                <button className='btn btn-primary me-2' onClick={handleEditClick}>Edit</button>
                                <button className='btn btn-danger text-white' onClick={handleDeleteClick}>Delete</button>
                                <Link to={'/competition/horse/upload?competetionid=' + competitionId} className='btn btn-primary ms-2'>Upload Horse List</Link>
                                <Link to={'/competition/horse/resultinput?competetionid=' + competitionId} className='btn btn-primary ms-2'>Input Results</Link>

                            </div>
                        }
                        {state.isEditting &&
                            <div className='col-auto'>
                                <button type='submit' className='btn btn-success text-white me-2' onClick={handleSubmit(handleSaveClick)}>Save</button>
                                <button className='btn btn-primary' onClick={handleEditClick}>Cancel</button>
                            </div>
                        }
                    </div>
                    <div className="row">
                        <div className="col-lg">
                            <div className='row mb-3'>
                                <div className='col'>
                                    <label htmlFor='competitionName' className='form-label'>Name:</label>
                                    <input type='text' className='form-control' id='competitionName' autoComplete='off' {...register('competition.name', { required: true })} disabled={!state.isEditting} />
                                    {errors.competition?.name?.type === 'required' && <div className='text-danger form-text'>Name is required</div>}
                                </div>
                                <div className="col">
                                    <label htmlFor='competitionClassNumber' className='form-label'>Class Number:</label>
                                    <input type='text' className='form-control' id='competitionClassNumber' autoComplete='off' {...register('competition.classNumber')} disabled={!state.isEditting} />
                                </div>
                                <div className="col">
                                    <label htmlFor="competitionStatus" className="form-label">Status:</label>
                                    <select id="competitionStatus" className="form-select" autoComplete='off' {...register('competition.status')} disabled={!state.isEditting}>
                                        {renderStatusOptions()}
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col">
                                    <label htmlFor='competitionDiscipline' className='form-label'>Discipline:</label>
                                    
                                    <select name="DisciplineId" id="" className='form-select' 
                                    disabled={!state.isEditting} 
                                    {...register('DisciplineId', {
                                        required: "Discipline is required"
                                    })}
                                    defaultValue={state.competition.disciplineId || ""} // 👈 this is key

                                    >
                                        <option value="">Select Discipline</option>
                                        {deciples?.map((discipline) => (
                                            <option key={discipline.id} value={discipline.id}
                                            
                                            >{discipline.discipline_name}
                                            
                                            </option>
                                        ))}
                                    </select>


                                    {/* <Controller
                                        control={control}
                                        name='competition.discipline'
                                        rules={{ required: true }}
                                        render={({ field: { onChange, value } }) => (
                                            <DisciplineSelector className='form-control' id='competitionDiscipline' value={value} onChange={onChange} disabled={!state.isEditting} />
                                        )}
                                    /> */}
                                    {errors.competition?.discipline?.type === 'required' && <div className='text-danger form-text'>Discipline is required</div>}
                                </div>
                                  <div className="col">
                                    <label htmlFor="competittionStartDateTime" className="form-label">Start Date and Time:</label>
                                    <input type="datetime-local" className="form-control" id='competittionStartDateTime' autoComplete='off' {...register('competition.startDateTime')} disabled={!state.isEditting} />
                                </div>
                                {/* <div className="col">
                                    <label htmlFor='competitionShow' className='form-label'>Show:</label>
                                    <Controller
                                        control={control}
                                        name='competition.show'
                                        rules={{ required: true }}
                                        render={({ field: { onChange, value } }) => (
                                            <ShowSelector className='form-control' id='competitionShow' value={value} onChange={onChange} disabled={true} />
                                        )}
                                    />
                                    {errors.competition?.show?.type === 'required' && <div className='text-danger form-text'>Show is required</div>}
                                </div> */}
                            </div>
                            <div className="row mb-5">
                              
                                <div className="col">
                                    <label htmlFor="competitionOrder" className="form-label">Order:</label>
                                    <input type="number" min={1} className="form-control" id='competitionOrder' autoComplete='off' {...register('competition.order')} disabled={!state.isEditting} />
                                </div>

                                  <div className="col">
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <h3 className='col'>Horses</h3>
                            {state.isEditting &&
                                <div className='col-auto'>
                                    <button className='btn btn-primary me-2' onClick={handleNewCompetitionHorseClick}>
                                        <i className='bi bi-plus-lg me-2'></i>
                                        Add
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                    <FormObjectList
                        objectCount={fields.length}
                        objects={fields}
                        keyExtractor={(index) => fields[index].id}
                        render={renderCompetitionHorse}
                    />

                    <div ref={divForScroll} style={{ height: '200px' , width: '100%',backgroundColor: 'white'}}></div>
                </form>
            }
        </div>
    );
}

export default CompetitionEdit;